









































import {
  createComponent,
  inject,
  computed,
  SetupContext
} from "@vue/composition-api";
import RealTimeTransferKey from "@/components/real-time-transfer-key";

export default createComponent({
  components: {},
  setup(props: {}, context: SetupContext) {
    const realTimeTransferStore = inject(RealTimeTransferKey);
    if (!realTimeTransferStore) {
      throw new Error(`${RealTimeTransferKey} is not provided`);
    }

    const errorMessage = computed(() => realTimeTransferStore.errorMessage);

    return {
      errorMessage
    };
  }
});
